<template>
   <div>
      <h6 class="heading-small text-muted mb-4 text-truncate">Configure {{documentName}} - {{currentDocumentTypeCode}} </h6>
      <form id="form-proper">
          <base-input alternative="" label="Document Name" disabled placeholder="" v-model="documentName" input-classes="form-control" />
          <base-input alternative="" label="Friendly Code" disabled placeholder="" v-model="documentFriendlyCode" input-classes="form-control" />
          <hr class="my-3">
          <label class="form-control-label">
            Additional Configuration
          </label>

          <a-tabs defaultActiveKey="1" tabPosition="top">
            <a-tab-pane tab="Price or Cost" key="1">
              <p style="line-height: 90%;"><small>During transaction, system automatically picks up a price when a product is identified. Please select which price or cost do you want the system to use</small></p>
              <div class="col">
                <a-select style="width: 100%" :value="priceOrCost" @change="changePriceOrCost">
                  <a-select-option v-for="option in filteredPriceCostOptions" v-bind:key="option">{{option}}</a-select-option>
                </a-select>
              </div>
            </a-tab-pane>

            <a-tab-pane tab="Reference Captions" key="2">
              <p style="line-height: 90%;"><small>References are extra codes that you can use to store additional information.</small></p>

              <div class="row">
                <div class="col text-center">
                  <small>Reference Name</small>
                </div>
                <div class="col text-center">
                  <small>Reference Values</small>
                </div>
                <div class="col text-center">
                  <small>Allow duplicate values?</small>
                </div>
              </div>

              <div v-for="(reference, index) in references" v-bind:key="'references'+index" class="row pt-2">
                <div class="col text-center">
                  <a-input :placeholder="reference.name" v-model="reference.name" />
                </div>
                <div class="col text-center">
                  <a-input placeholder="values" v-model="reference.value" />
                </div>
                <div class="col text-center">
                  <a-checkbox v-model="reference.duplicate" ></a-checkbox>
                </div>
              </div>
            </a-tab-pane>

            <a-tab-pane tab="Editor Behavior" key="3">
              <div class="row mx-0">
                <p style="line-height: 90%;"><small>In some cases, you may want to restrict user from entering too many lines per document or transaction</small></p>
              </div>
              <div class="row mx-0">
                <div class='col'>
                  <a-checkbox class='pt-2' v-model='editorBehavior.lineRestrictionCheckbox' @change='toggleLineRestrictionCheckbox'>Restrict maximum number of lines</a-checkbox>
                </div>
                <div class='col-auto'>
                  <a-input-number style="width: 100%" :min="1" v-model='editorBehavior.lineRestrictionInput' placeholder='lines' :disabled="editorBehavior.lineRestrictionCheckboxIsDisabled"/>
                </div>
              </div>
              <div class="row mx-0">
                <div class="col-md-12 col-lg-12 col-sm-12 col-xs-12 p-0  mt-3">
                  <p style="line-height: 90%;"><small>Input allowed number of item lines in csv when mass uploading of products</small></p>
                </div>
                <div class="col-lg-3 col-md-3 col-xs-3 ">
                  <a-input-number style="width: 100%" :min="1" v-model='editorBehavior.maxMassUploadLineRestrictionInput' placeholder='lines'/>
                </div>
              </div>
              <p class='mb-0 mt-3'><small>Encoding Behavior</small></p>
              <div class="row mx-0">
                <a-radio-group defaultValue="S" v-model="editorBehavior.radio">
                  <a-radio value="S">Standard - Do not allow duplicate product</a-radio> <br>
                  <a-radio value="L">Linear - Allow duplicate entries, but editing is disabled</a-radio> <br>
                  <a-radio value="P">POS - Quantity entered is added to previous quantity</a-radio>
                </a-radio-group>
              </div>
              <p class='mb-0 mt-3'><small>Prefix Search</small></p>
              <div class="row mx-0">
                <a-select style="width: 100%" v-model="editorBehavior.prefixSearch" allowClear>
                  <a-select-option v-for="option in prefixSearchOption" :key="option.value">{{option.name}}</a-select-option>
                </a-select>
              </div>
              <p class='mb-0 mt-3'><small>Revenue Crediting Mode</small></p>
              <div class="row mx-0">
                <a-select style="width: 100%" v-model="editorBehavior.revenueCreditingMode">
                  <a-select-option v-for="option in revenueCreditingModeOption" :key="option.value">{{option.name}}</a-select-option>
                </a-select>
              </div>

            </a-tab-pane>

            <a-tab-pane tab="Additional Editor Behavior" key="4">
              <p style="line-height: 90%;"><small>Here are more behavior which you may configure</small></p>
              <ul style="list-style-type:none" class='p-0'>
                <li v-if='currentDocumentTypeCode=="OROTRQ" || currentDocumentTypeCode=="OROCSQ" || currentDocumentTypeCode=="RECDEL" || currentDocumentTypeCode=="ORIPOX" || currentDocumentTypeCode=="RECTRX" || currentDocumentTypeCode=="RELTRX"'><a-checkbox v-model="additionalEditorBehaviorCheckboxes.restrictWithoutOriginDoc">Restrict creating document without origin document</a-checkbox></li>
                <li v-if='currentDocumentTypeCode=="RECDEL" || currentDocumentTypeCode=="RELRSR" || currentDocumentTypeCode=="ORIPOX"'><a-checkbox v-model="additionalEditorBehaviorCheckboxes.filterProductBySupplier">Filter product by supplier</a-checkbox></li>
                <li ><a-checkbox v-model="additionalEditorBehaviorCheckboxes.confirmDocumentStatus">Enable confirmed/unconfirmed document status</a-checkbox></li>
                <li v-if='currentDocumentTypeCode=="RECDEL" || currentDocumentTypeCode=="RECTRX"'><a-checkbox v-model="additionalEditorBehaviorCheckboxes.updateLastArrivalDateWhenPosted">Update products's last arrival date when posted</a-checkbox></li>
                <li v-if='currentDocumentTypeCode=="RECDEL" || currentDocumentTypeCode=="RECTRX"'><a-checkbox v-model="additionalEditorBehaviorCheckboxes.updateLastArrivalQuantityWhenPosted">Update products's last arrival quantity when posted</a-checkbox></li>
                <li v-if='currentDocumentTypeCode=="RECDEL" || currentDocumentTypeCode=="RECTRX"'><a-checkbox v-model="additionalEditorBehaviorCheckboxes.updateLastArrivalSupplierWhenPosted">Update products's last arrival supplier when posted</a-checkbox></li>
                <li><a-checkbox v-model="additionalEditorBehaviorCheckboxes.itemDescEditForPrinting">Allow editing of item description for printing purposes</a-checkbox></li>
                <li v-if='currentDocumentTypeCode!="ORIPOX" && currentDocumentTypeCode!="ORIASN" && currentDocumentTypeCode!="RECDEL"'><a-checkbox v-model="additionalEditorBehaviorCheckboxes.enableAddCharges">Enable add charges</a-checkbox></li>
                <li v-if='currentDocumentTypeCode=="RECDEL" || currentDocumentTypeCode=="ORIPOX"'><a-checkbox v-model="additionalEditorBehaviorCheckboxes.packageDefaultItemEncoding">Use package as default item in encoding</a-checkbox></li>
                <li v-if='currentDocumentTypeCode=="RECDEL" || currentDocumentTypeCode=="ORIPOX"'><a-checkbox v-model="additionalEditorBehaviorCheckboxes.showVatExclusiveAmount">Enable showing VAT-exclusive amounts in document</a-checkbox></li>
                <li><a-checkbox v-model="additionalEditorBehaviorCheckboxes.auditTrail">Enable audit trail</a-checkbox></li>
                <li v-if="['OROTRQ', 'OROCSQ', 'ORITRQ', 'ORICSQ', 'RECTRX', 'RELTRX', 'OTHPUR', 'ORIPOX', 'RECDEL', 'RELRSR', 'ORITRQ', 'OROTRQ', 'RECTRX', 'RELTRX'].includes(currentDocumentTypeCode)"><a-checkbox v-model="additionalEditorBehaviorCheckboxes.termsAndDiscount">Hide terms and discount in document editor</a-checkbox></li>
                <li v-if='currentDocumentTypeCode=="RECDEL"'><a-checkbox v-model="additionalEditorBehaviorCheckboxes.showPoBalanceQuantityWithColorCoding">Show PO balance quantity with color coding</a-checkbox></li>
                <li v-if='currentDocumentTypeCode=="RECTRX" || currentDocumentTypeCode=="RELTRX"'><a-checkbox v-model="additionalEditorBehaviorCheckboxes.restrictBackDatingInDocuments">Restrict back dating of date in documents</a-checkbox></li>
                <li><a-checkbox v-model="additionalEditorBehaviorCheckboxes.fourDecimalPlaces">Allow four (4) decimal places in subtotal</a-checkbox></li>
                <li v-if='currentDocumentTypeCode=="ORISOX"'><a-checkbox v-model="additionalEditorBehaviorCheckboxes.allowPromotionComputation">Allow promotion computation</a-checkbox></li>
                <li v-if='currentDocumentTypeCode=="ORISOX" || currentDocumentTypeCode=="OTHSIN"'><a-checkbox v-model="additionalEditorBehaviorCheckboxes.automaticPostingOnSave">Automatic posting on save</a-checkbox></li>
                <li v-if='currentDocumentTypeCode=="ORISOX" || currentDocumentTypeCode=="RELDDE" || currentDocumentTypeCode=="OTHSIN"'><a-checkbox v-model="additionalEditorBehaviorCheckboxes.allowPaymentOnPosting">Allow payment on posting</a-checkbox></li>
                <li v-if='currentDocumentTypeCode=="ORIPOX"'><a-checkbox v-model="additionalEditorBehaviorCheckboxes.enableRecordingOfInitialDeposit">Enable Recording of Initial Deposit on posting</a-checkbox></li>
                <li v-if='currentDocumentTypeCode=="RELDDE"'><a-checkbox v-model="additionalEditorBehaviorCheckboxes.allowCreationOfDDWithoutSO">Allow Creation of DD without SO</a-checkbox></li>
                <li v-if='currentDocumentTypeCode=="RELDDE"'><a-checkbox @change="checkAutocreationOfSI(additionalEditorBehaviorCheckboxes.autoCreateSalesInvoiceOnPosting,'create')" v-model="additionalEditorBehaviorCheckboxes.autoCreateSalesInvoiceOnPosting">Auto create Sales Invoice on posting</a-checkbox></li>
                <li v-if='currentDocumentTypeCode=="RELDDE"'><a-checkbox @change="checkAutocreationOfSI(additionalEditorBehaviorCheckboxes.autoCreateAndPostSalesInvoiceOnPosting,'create&post')" v-model="additionalEditorBehaviorCheckboxes.autoCreateAndPostSalesInvoiceOnPosting">Auto create and post Sales Invoice on posting</a-checkbox></li>
                <li v-if='currentDocumentTypeCode=="RECTRX" || currentDocumentTypeCode=="RELTRX" || currentDocumentTypeCode=="OTHTRA" || currentDocumentTypeCode=="ORIPOX" || currentDocumentTypeCode=="RECDEL" || currentDocumentTypeCode=="RECADJ" || currentDocumentTypeCode=="RELADJ" || currentDocumentTypeCode=="ORISOX" || currentDocumentTypeCode=="RELDDE"'><a-checkbox v-model="additionalEditorBehaviorCheckboxes.displayAllReferences">Display all references</a-checkbox></li>
                <li v-if='currentDocumentTypeCode=="RECTRX" || currentDocumentTypeCode=="RELTRX" || currentDocumentTypeCode=="OTHTRA" || currentDocumentTypeCode=="ORIPOX" || currentDocumentTypeCode=="RECDEL" || currentDocumentTypeCode=="RECADJ" || currentDocumentTypeCode=="RELADJ"'><a-checkbox v-model="additionalEditorBehaviorCheckboxes.displayTotalQuantity">Display total quantity</a-checkbox></li>
                <li v-if='currentDocumentTypeCode=="ORIPOX"'><a-checkbox v-model="additionalEditorBehaviorCheckboxes.enableShowingSupplierStockNumber">Enable showing Supplier Stock Number in document</a-checkbox></li>
                <li v-if='currentDocumentTypeCode=="RELDDE"'><a-checkbox v-model="additionalEditorBehaviorCheckboxes.displayRemarks">Display Remarks</a-checkbox></li>
                <li v-if='currentDocumentTypeCode=="RELDDE"'><a-checkbox v-model="additionalEditorBehaviorCheckboxes.displayShipOnTimeSLA">Display Ship-on-Time SLA</a-checkbox></li>
                <li v-if='currentDocumentTypeCode=="ORISOX"'><a-checkbox @change="checkAutocreationOfDD(additionalEditorBehaviorCheckboxes.autoCreatePostDD,'DD')" v-model="additionalEditorBehaviorCheckboxes.autoCreatePostDD">Auto create and post a Delivery Document upon posting</a-checkbox></li>
                <li v-if='currentDocumentTypeCode=="ORISOX"'><a-checkbox @change="checkAutocreationOfDD(additionalEditorBehaviorCheckboxes.autoCreatePostDDAndSI,'DD&SI')" v-model="additionalEditorBehaviorCheckboxes.autoCreatePostDDAndSI">Auto create/post a Delivery Document and Sales Invoice upon posting</a-checkbox></li>
                <li v-if='currentDocumentTypeCode=="ORISOX" || currentDocumentTypeCode=="RELDDE" || currentDocumentTypeCode=="OTHSIN"'><a-checkbox v-model="additionalEditorBehaviorCheckboxes.displayVatAmount">Display Vat Amount</a-checkbox></li>
                <li v-if='currentDocumentTypeCode=="ORISOX" || currentDocumentTypeCode=="RELDDE" || currentDocumentTypeCode=="OTHSIN"'><a-checkbox v-model="additionalEditorBehaviorCheckboxes.displayNetAmountWOVat">Display Net Amount Without VAT</a-checkbox>
                  <br>
                  <a-input placeholder="values" v-if="additionalEditorBehaviorCheckboxes.displayNetAmountWOVat" v-model="additionalEditorBehaviorCheckboxes.displayNetAmountWOVatLabel" default-value="Net Amount w/o VAT"/>
                </li>
              </ul>
            </a-tab-pane>

            <a-tab-pane v-if="showIncomingOrder && incomingOrder!=undefined" tab="Incoming Order" key="5">
              <p style="line-height: 90%;"><small>The settings applies to incoming order document</small></p>
              <div class="row">
                <div class="col-7 pt-1">
                  Number of days before cancellation:
                </div>
                <div class="col-5">
                  <a-input-number style="width: 100%" :min="1" :max="100" v-model='incomingOrder.cancellationDays'/>
                </div>
              </div>
              <div class="row m-0 pt-2">
                <ul style="list-style-type:none" class='mb-0 pl-0'>
                  <li v-if="currentDocumentTypeCode=='ORITRQ'"><a-checkbox v-model='incomingOrder.createStockRequest'>Create stock request for serving document when stock request on order is posted</a-checkbox></li>
                  <li v-if="currentDocumentTypeCode=='ORITRQ'"><a-checkbox v-model='incomingOrder.postStockRequest'>Post stock request for serving document when stock request on order is posted</a-checkbox></li>
                  <li v-if="currentDocumentTypeCode=='ORICSQ'"><a-checkbox v-model='incomingOrder.createConcessionStockRequest'>Create concession stock request for serving document when stock request on order is posted</a-checkbox></li>
                  <li v-if="currentDocumentTypeCode=='ORICSQ'"><a-checkbox v-model='incomingOrder.postConcessionStockRequest'>Post concession stock request for serving document when stock request on order is posted</a-checkbox></li>
                  <li v-if="currentDocumentTypeCode=='RELSLO'"><a-checkbox v-model='incomingOrder.createRECSLI'>Create sublocation transfer in document when sublocation transfer out is posted</a-checkbox></li>
                  <li v-if="currentDocumentTypeCode=='RELSLO'"><a-checkbox v-model='incomingOrder.postRECSLI'>Post sublocation transfer in document when sublocation transfer out is posted</a-checkbox></li>
                  <li v-if="currentDocumentTypeCode=='ORIPOX'"><a-checkbox v-model='incomingOrder.rememberLastDiscount'>Remember last discount</a-checkbox></li>
                  <li v-if="currentDocumentTypeCode=='ORIPOX'"><a-checkbox v-model='incomingOrder.useLastDiscount'>Use last discount</a-checkbox></li>
                  <li v-if="currentDocumentTypeCode=='ORIPOX'" hidden><a-checkbox v-model='incomingOrder.requireSupplierInPo'>Require Supplier in PO</a-checkbox></li>
                  <li v-if="currentDocumentTypeCode=='ORIPOX'"><a-checkbox v-model='incomingOrder.setZeroDefaultQuantityAutoPopulateSupplier'>Set to zero the default quantity in auto populate by supplier</a-checkbox></li>
                  <li v-if="currentDocumentTypeCode=='ORIPOX'"><a-checkbox v-model='incomingOrder.deleteZeroQuantityInSaving'>Delete zero quantity in saving document</a-checkbox></li>
                  <li v-if="currentDocumentTypeCode=='ORIPOX'"><a-checkbox v-model='incomingOrder.updateOrderingCostPosting'>Update ordering cost during posting</a-checkbox></li>
                  <li v-if="currentDocumentTypeCode=='ORIPOX'"><a-checkbox v-model='incomingOrder.disableAutocreationAlternateSupplierPosting'>Disable autocreation of alternate supplier during posting</a-checkbox></li>
                </ul>
              </div>
            </a-tab-pane>

            <a-tab-pane v-if="showOutgoingOrder && outgoingOrder!=undefined" tab="Outgoing Order" key="5">
              <p style="line-height: 90%;"><small>The settings applies to outgoing order document</small></p>
              <div class="row">
                <div class="col-7 pt-1">
                  Number of days before cancellation:
                </div>
                <div class="col-5">
                  <a-input-number style="width: 100%" :min="1" :max="100" v-model='outgoingOrder.cancellationDays' />
                </div>
              </div>
              <div class="row m-0 pt-2">
                <ul style="list-style-type:none" class='mb-0 pl-0'>
                  <li><a-checkbox v-model='outgoingOrder.warnNotEnoughQuantity'>Warn user if there is not enough on hand quantity</a-checkbox></li>
                  <li><a-checkbox v-model='outgoingOrder.restrictNotEnoughQuantity'>Restrict adding item if there is not enough on hand quantity</a-checkbox></li>
                </ul>
              </div>
            </a-tab-pane>

            <a-tab-pane v-if="showReceivingDocument && receivingDocument!=undefined" tab="Receiving Document" key="5">
              <p style="line-height: 90%;"><small>The settings only applies to Receiving Documents (any document that increases the inventory of the system). For Example: Receiving Report, Adjustment In</small></p>
                <ul style="list-style-type:none" class='mb-0 pl-0'>
                  <li><a-checkbox v-model='receivingDocument.rememberLastDiscount'>Remember last discount</a-checkbox></li>
                  <li><a-checkbox v-model='receivingDocument.useLastDiscount'>Use last discount</a-checkbox></li>
                  <li><a-checkbox v-model='receivingDocument.updateLandedCostPosting'>Update landed cost during posting</a-checkbox></li>
                  <li><a-checkbox v-model='receivingDocument.updateOrderingCostPosting'>Update ordering cost during posting</a-checkbox></li>
                  <li><a-checkbox v-model='receivingDocument.enableInvoiceQuantity'>Enable invoice quantity</a-checkbox></li>
                  <li><a-checkbox v-if="!((currentDocumentTypeCode=='RECTRX') || (currentDocumentTypeCode=='RECADJ'))" v-model='receivingDocument.allowZeroQuantityFromAutoGeneratedDocument'>Enable to allow zero quantity from auto-generated document </a-checkbox></li>
                  <li><a-checkbox v-if="!(currentDocumentTypeCode=='RECADJ')" v-model='receivingDocument.deleteZeroQuantityPosting'>Delete zero quantity in posting document</a-checkbox></li>
                  <li><a-checkbox v-if="!((currentDocumentTypeCode=='RECTRX') || (currentDocumentTypeCode=='RECADJ'))" v-model='receivingDocument.disableAutocreationAlternateSupplierPosting'>Disable autocreation of alternate supplier during posting</a-checkbox></li>
                  <li><a-checkbox v-if="!((currentDocumentTypeCode=='RECTRX') || (currentDocumentTypeCode=='RECADJ'))" v-model='receivingDocument.onlySupervisorChangeDocumentDate'>Only supervisor can change document date</a-checkbox></li>
                  <li><a-checkbox v-if="(currentDocumentTypeCode=='RECDEL')" v-model='receivingDocument.setZeroDefaultQuantityPo'>Set to zero the default quantity when created from PO</a-checkbox></li>
                  <li><a-checkbox v-if="(currentDocumentTypeCode=='RECTRX')" v-model='receivingDocument.setZeroDefaultQuantityPo'>Set to zero the default quantity when created from STO</a-checkbox></li>
                  <li><a-checkbox v-model='receivingDocument.skipCheckingCostLayerCancellingDocument'>Skip checking cost layer when cancelling document</a-checkbox></li>
                </ul>
            </a-tab-pane>

            <a-tab-pane v-if="showReleasingDocument && releasingDocument!=undefined" tab="Releasing Document" key="5">
              <p style="line-height: 90%;"><small>The settings only applies to Releasing Documents (any document which decreases the inventory of the system)</small></p>
                <ul style="list-style-type:none" class='mb-0 pl-0'>
                  <li><a-checkbox v-model='releasingDocument.warnNotEnoughQuantity'>Warn user if there is not enough on hand quantity</a-checkbox></li>
                  <li><a-checkbox v-model='releasingDocument.allowPostingNotEnoughtQuantity'>Allow posting to proceed even if there is not enough on hand quantity</a-checkbox></li>
                  <li><a-checkbox v-model='releasingDocument.updatePriceFromCostPosting'>Update price from cost when posting</a-checkbox></li>
                  <li><a-checkbox v-model='releasingDocument.restrictAddingItemNotEnoughQuantity'>Restrict adding item if there is not enough on hand quantity</a-checkbox></li>
                </ul>
            </a-tab-pane>

            <a-tab-pane v-if="showReceivingDocumentWithOrder && receivingDocumentWithOrder!=undefined" tab="Receiving Document with Order" key="6">
              <p style="line-height: 90%;"><small>The settings only applies to Receiving Documents which have prior Order Documents. For Example: The Receving Report</small></p>
                <ul style="list-style-type:none" class='mb-0 pl-0'>
                  <li><a-checkbox v-model='receivingDocumentWithOrder.markPartiallyDeliveredDone'>Mark partially delivery as done</a-checkbox></li>
                  <li><a-checkbox v-model='receivingDocumentWithOrder.autoCreatePurchaseOrderExceedingQuantity'>Auto create another Purchase Order when Receiving Report quantity exceeds Purchase Order Quantity</a-checkbox></li>
                  <li><a-checkbox v-model='receivingDocumentWithOrder.populateReceivingReportQuantityBasedOnPurchaseOrder'>Populate Receiving Report Quantity based on Purchase Order Quantity</a-checkbox></li>
                </ul>
            </a-tab-pane>

            <a-tab-pane v-if="showReleasingDocumentWithOrder && releasingDocumentWithOrder!=undefined" tab="Releasing Document with Order" key="7">
              <p style="line-height: 90%;"><small>The settings only applies to Releasing Documents which have prior Order Documents. For Example: The Stock Transfer with prior Stock Request</small></p>
                <ul style="list-style-type:none" class='mb-0 pl-0'>
                  <li><a-checkbox v-model='releasingDocumentWithOrder.markPartiallyDeliveredDone'>Mark partially delivery as done</a-checkbox></li>
                </ul>
            </a-tab-pane>


            <a-tab-pane v-if="showTransferDocument && transferDocument!=undefined" tab="Transfer Document" key="8">
              <p style="line-height: 90%;"><small>The settings only applies to Transfer Documents</small></p>
                <ul style="list-style-type:none" class='mb-0 pl-0'>
                  <li><a-checkbox v-model='transferDocument.createTransferInWhenTransferOutPosted'>Create transfer in document when transfer out is posted</a-checkbox></li>
                  <li><a-checkbox v-model='transferDocument.postTransferInWhenTransferOutPosted'>Post transfer in document when transfer out is posted</a-checkbox></li>
                </ul>
            </a-tab-pane>

            <a-tab-pane v-if="showOrderSourceMode && orderSource!=undefined" tab="Order Source Mode" key="9">
              <p style="line-height: 90%;"><small>The settings only applies to Sales Order Document <br> <br> Enabling this setting will change selection of sublocation to order source for Sales Order, Delivery Document and Sales Invoice</small></p>
              <a-checkbox v-model='orderSource.enableOrderSourceMode'>Enable Order Source Mode</a-checkbox>
              <a-select v-if='orderSource.enableOrderSourceMode' mode="tags" class="col-12 mt-2" v-model='orderSource.orderSources' style="width: 100%;" placeholder='Please define order sources' input-classes="form-control"></a-select>
            </a-tab-pane>
            <a-tab-pane v-if="showPrintSettings" tab="Print Settings" key="10">
              <ul style="list-style-type:none" class='p-0'>
                <li v-if="currentDocumentTypeCode=='ORIPOX'"><a-checkbox v-model="printSettings.enableShowingInitialDepositField">Enable showing initial Deposit field</a-checkbox></li>
                <li v-if="currentDocumentTypeCode=='ORIPOX'"><a-checkbox v-model="printSettings.enableShowingBalanceField">Enable showing Balance field</a-checkbox></li>
                <li v-if="currentDocumentTypeCode=='ORIPOX'"><a-checkbox v-model="printSettings.enableShowingPriceInclusionField">Enable showing Price Inclusion field</a-checkbox></li>
                <li v-if="currentDocumentTypeCode=='ORIPOX'"><a-checkbox v-model="printSettings.enableShowingComment1Field">Enable showing Comment 1 field</a-checkbox></li>
                <li v-if="currentDocumentTypeCode=='ORIPOX'"><a-checkbox v-model="printSettings.enableShowingComment2Field">Enable showing Comment 2 field</a-checkbox></li>
                <li v-if="currentDocumentTypeCode=='ORIPOX'"><a-checkbox v-model="printSettings.includeImageInPrintout">Include Product Image in printout document</a-checkbox></li>
                <li v-if="currentDocumentTypeCode=='ORIPOX'"><a-checkbox v-model="printSettings.showStockNoInProductList">Show Supplier Stock No. column in the product list</a-checkbox></li>
                <li v-if="currentDocumentTypeCode=='ORIPOX'"><a-checkbox v-model="printSettings.showDesignAndSizeInProductList">Show Design and Size column in the product list</a-checkbox></li>
                <li v-if="currentDocumentTypeCode=='ORIPOX'"><a-checkbox v-model="printSettings.showSerialNoInProductList">Show serial No. column in the product list</a-checkbox></li>
                <li><a-checkbox v-model="printSettings.showDiscountAmount">Show Discount Amount</a-checkbox></li>
                <li><a-checkbox v-model="printSettings.showTotalVat">Show VAT amount</a-checkbox></li>
                <li><a-checkbox v-model="printSettings.showNetAmountWithoutVat">Show Net Amount W/o VAT </a-checkbox></li>
                <li><a-checkbox v-model="printSettings.showTotalPrice">Show Total Price</a-checkbox></li>
                
                <li><a-checkbox v-model="printSettings.enableLandscapePrinting">Enable landscape PDF Printing</a-checkbox></li>
                <li v-if="currentDocumentTypeCode!='ORISOX' && currentDocumentTypeCode!='RELDDE' && currentDocumentTypeCode!='OTHSIN'"><a-checkbox v-model="printSettings.showRefCode">Enable showing Reference Code field</a-checkbox></li>
                <li v-if="currentDocumentTypeCode=='ORISOX' || currentDocumentTypeCode=='RELDDE' || currentDocumentTypeCode=='OTHSIN' || currentDocumentTypeCode=='ORORSO'"><a-checkbox v-model="printSettings.showOtherCharges">show Other Charges</a-checkbox></li>
              </ul>
            </a-tab-pane>
            <a-tab-pane v-if="showCustomerReturn && customerReturn!=undefined" tab="Customer Return" key="11">
              <p style="line-height: 90%;"><small>The settings only applies to Customer Return Documents</small></p>
                <ul style="list-style-type:none" class='mb-0 pl-0'>
                  <li>
                    <a-checkbox v-model="customerReturn.limitReturnPeriod">Set a time limit (in days) for returning items.</a-checkbox>
                    <ul>
                      <li>
                        <a-input-number  :disabled="!customerReturn.limitReturnPeriod" style="width: 50%" :min="1" v-model='customerReturn.returnGracePeriod'> Allowable Grace Period (in days) for returns.</a-input-number>
                      </li>
                    </ul>
                  </li>
                </ul>
            </a-tab-pane>
            <a-tab-pane tab="Action History" key="12">
              <div>
                <h6 class="heading-small text-muted mb-4 text-truncate">Document Configuration Action History</h6>
                <a-table :columns="historyColumns" :dataSource="historyData" size="small"/>
                </div>
            </a-tab-pane>

          </a-tabs>
          <br/>
          <br/>
          <div style="position: absolute; bottom: 0px;right: 0px; width: -webkit-fill-available; background-color: #f2f2f2 ;padding: 10px;">
            <a-spin :tip="spinMessage" :spinning="spinning">
              <button type="button" class="btn btn-primary float-right" @click.prevent="save">Save</button>
            </a-spin>
          </div>
      </form>
   </div>
  
</template>

<script>
  import HTTPRequest from '../../controllers/httpRequest.js'
  import { mapState } from 'vuex'
  import secureStorage from '../../controllers/secureStorage'
  import moment from 'moment';

  var component_x;
  export default {
    data() {
      return {
        spinMessage: 'Saving......',
        spinning : false,
        currentDocumentTypeId: null,
        currentDocumentTypeCode: null,
        documentName: '',
        documentCode: '',
        documenttransCode: '',
        documentFriendlyCode: '',

        priceOrCost: "Landed Cost", //Default Selected Price or Cost
        priceCostOptions: [
          "Landed Cost", "Retail Price", "Ordering Cost", "Original Cost","Wholesale Price",
        ],

        references: [
          {name: 'reference', value: '', duplicate: false},
          {name: 'reference 2', value: '', duplicate: false},
          {name: 'reference 3', value: '', duplicate: false},
          {name: 'reference 4', value: '', duplicate: false},
          {name: 'reference 5', value: '', duplicate: false},
          {name: 'reference 6', value: '', duplicate: false},
          {name: 'reference 7', value: '', duplicate: false},
          {name: 'reference 8', value: '', duplicate: false},
          {name: 'reference 9', value: '', duplicate: false},
          {name: 'reference 10', value: '', duplicate: false},
        ],

        prefixSearchOption:[
          {name: 'Brand Name', value: 'brand_name'},
          {name: 'Stock no', value: 'stock_no'},
          {name: 'Reference Code', value: 'reference_code'},
        ],

        editorBehavior: {
          lineRestrictionCheckboxIsDisabled: true,
          maxMassUploadLineRestrictionInput:null,
          prefixSearch: null,
          revenueCreditingMode:"M"
        },
        editorBehaviorRadioOptions: [
          { label: 'Standard - Do not allow duplicate product', value: 'S' },
          { label: 'Linear - Allow duplicate entries, but editing is disabled', value: 'L' },
          { label: 'POS - Quantity entered is added to previous quantity', value: 'P' },
        ],
        revenueCreditingModeOption:[
          {name: 'Requesting', value: 'R'},
          {name: 'Target', value: 'T'},
          {name: 'Manual', value: 'M'},
        ],

        additionalEditorBehaviorCheckboxes: {
          restrictWithoutOriginDoc: false,
          confirmDocumentStatus: false,
          itemDescEditForPrinting: false,
          auditTrail: false,
          enableAddCharges: false,
          termsAndDiscount: true,
          fourDecimalPlaces: false,
          filterProductBySupplier: false,
          updateLastArrivalDateWhenPosted: true,
          updateLastArrivalQuantityWhenPosted: true,
          updateLastArrivalSupplierWhenPosted: true,
          packageDefaultItemEncoding: false,
          showVatExclusiveAmount: true,
          showPoBalanceQuantityWithColorCoding: false,
          restrictBackDatingInDocuments: false,
          allowPromotionComputation: false,
          automaticPostingOnSave: false,
          allowPaymentOnPosting: false,
          autoCreateSalesInvoiceOnPosting: false,
          autoCreateAndPostSalesInvoiceOnPosting: false,
          allowCreationOfDDWithoutSO:false,
          autoCreatePostDDAndSI:false,
          displayAllReferences:false,
          displayTotalQuantity:false,
          enableShowingSupplierStockNumber:false,
          enableRecordingOfInitialDeposit:false,
          displayRemarks:false,
          displayShipOnTimeSLA:false,
          autoCreatePostDD: false,
          displayVatAmount: false,
          displayNetAmountWOVat: false,
          displayNetAmountWOVatLabel:"Net Amount w/o VAT"
        },

        incomingOrder: {
          cancellationDays: 30,
          createStockRequest: false,
          postStockRequest: false,
          createRECSLI: false,
          postRECSLI: false,
          rememberLastDiscount: true,
          useLastDiscount: true,
          requireSupplierInPo: true,
          setZeroDefaultQuantityAutoPopulateSupplier: false,
          deleteZeroQuantityInSaving: true,
          updateOrderingCostPosting: true,
          disableAutocreationAlternateSupplierPosting: false,
        },
        outgoingOrder: {
          cancellationDays: 30,
          warnNotEnoughQuantity: false,
          restrictNotEnoughQuantity: false
        },
        receivingDocument: {
          rememberLastDiscount: false,
          useLastDiscount: true,
          updateLandedCostPosting: true,
          updateOrderingCostPosting: true,
          enableInvoiceQuantity: false,
          allowZeroQuantityFromAutoGeneratedDocument: false,
          deleteZeroQuantityPosting: false,
          disableAutocreationAlternateSupplierPosting: false,
          onlySupervisorChangeDocumentDate: true,
          setZeroDefaultQuantityPo: false,
          skipCheckingCostLayerCancellingDocument: false,
        },
        receivingDocumentWithOrder: {
          markPartiallyDeliveredDone: false
        },
        releasingDocument: {
          warnNotEnoughQuantity: true,
          allowPostingNotEnoughtQuantity: true,
          updatePriceFromCostPosting: false,
          restrictAddingItemNotEnoughQuantity: false,
        },
        releasingDocumentWithOrder: {
          markPartiallyDeliveredDone: false
        },

        transferDocument: {
          createTransferInWhenTransferOutPosted: false,
          postTransferInWhenTransferOutPosted: false
        },

        orderSource: {
          enableOrderSourceMode: false,
          orderSources: [],
        },
        printSettings:{
          enableShowingInitialDepositField:false,
          enableShowingPriceInclusionField:false,
          enableShowingBalanceField:false,
          enableShowingComment1Field:false,
          enableShowingComment2Field:false,
          includeImageInPrintout:false,
          showStockNoInProductList:false,
          showSerialNoInProductList:false,
          showDesignAndSizeInProductList:false,
          enableLandscapePrinting:false,
          showTotalVat:false,
          showDiscountAmount:false,
          showNetAmountWithoutVat:false,
          showTotalPrice:false,
          showOtherCharges:false,
        },
        customerReturn: {
          limitReturnPeriod: false,
          returnGracePeriod: 1
        },
        showIncomingOrder: false,
        showOutgoingOrder: false,
        showReceivingDocument: false,
        showReleasingDocument: false,
        showReceivingDocumentWithOrder: false,
        showReleasingDocumentWithOrder: false,
        showTransferDocument: false,
        showOrderSourceMode: false,
        showPrintSettings:false,
        showCustomerReturn:false,
        historyData: [],
        historyVisible: false,
        historyColumns: [
          {
          title: 'Action',
          dataIndex: 'action',
          },
          {
          title: 'Action By',
          dataIndex: 'action_by',
          },
          {
          title: 'Action At',
          dataIndex: 'action_at',
          customRender: (value) => <div>{moment(value).format('YYYY-MM-DD HH:mm:ss A')}</div>
          },
        ],
        initialSettings: {},
        logSettings: {},
        diffSettings: [],
      }
    },
    computed: {
        ...mapState(['currentProfile', 'currentApiURL', 'endPoint', 'profileId', 'parameters', 'serverType']),
        filteredPriceCostOptions(){
          return this.priceCostOptions.filter(o => o!= this.priceOrCost);
        }
    },
    mounted: async function() {
        component_x = this
        this.currentDocumentTypeId = secureStorage.getItem("documentTypeId")
        this.currentDocumentTypeCode = secureStorage.getItem("documentTypeCode")
        this.historyData = await HTTPRequest.getRequest(component_x.endPoint + "document_configuration_action_histories/"+this.currentDocumentTypeId+"?field_name=document_id", null);
        var data = await HTTPRequest.getRequest(component_x.endPoint+'/document_types?id='+ component_x.currentDocumentTypeId, null)
        if (data[0] != undefined) {
          component_x.documentName = data[0].name
          component_x.documentCode = data[0].type_code
          component_x.documenttransCode = data[0].trans_code
          component_x.documentFriendlyCode = data[0].friendly_code
        }
        var config = await HTTPRequest.getRequest(component_x.endPoint+'/document_types/get_document_type_settings?id='+ component_x.currentDocumentTypeId, null)
        if (config.document_type_settings != undefined) {
          component_x.priceOrCost = config.document_type_settings.priceOrCost
          // this.initialSettings.push( {"upriceOrCost": config.document_type_settings.priceOrCost} )
          this.initialSettings = Object.assign(this.initialSettings, {"upriceOrCost": config.document_type_settings.priceOrCost})
          // component_x.references = config.document_type_settings.references
          component_x.editorBehavior = config.document_type_settings.editorBehavior
          component_x.editorBehavior.maxMassUploadLineRestrictionInput = (config.document_type_settings.editorBehavior.maxMassUploadLineRestrictionInput) ? config.document_type_settings.editorBehavior.maxMassUploadLineRestrictionInput : 200
          // this.initialSettings.push( {"ueditorBehavior": this.pushInitSettings(config.document_type_settings.editorBehavior)} )
          this.initialSettings = Object.assign(this.initialSettings, {"ueditorBehavior": this.pushInitSettings(config.document_type_settings.editorBehavior)})
          component_x.additionalEditorBehaviorCheckboxes = config.document_type_settings.additionalEditorBehaviorCheckboxes
          // this.initialSettings.push( {"uadditionalEditorBehaviorCheckboxes": this.pushInitSettings(config.document_type_settings.additionalEditorBehaviorCheckboxes)} )
          this.initialSettings = Object.assign(this.initialSettings, {"uadditionalEditorBehaviorCheckboxes": this.pushInitSettings(config.document_type_settings.additionalEditorBehaviorCheckboxes)})
          if(config.document_type_settings.printSettings != undefined){
            // this.initialSettings.push( {"uprintSettings": this.pushInitSettings(config.document_type_settings.printSettings)} )
            this.initialSettings = Object.assign(this.initialSettings, {"uprintSettings": this.pushInitSettings(config.document_type_settings.printSettings)})
            component_x.printSettings = config.document_type_settings.printSettings
          } 

          // For NEW document form setting, kindly push to initialSettings; (u + settingsDesc)
          // this.initialSettings = Object.assign(this.initialSettings, {"usampleSettings": this.pushInitSettings(config.document_type_settings.usampleSettings)})

          if (config.document_type_settings.incomingOrder != undefined){
            // this.initialSettings.push( {"uincomingOrder": this.pushInitSettings(config.document_type_settings.incomingOrder)} )
            this.initialSettings = Object.assign(this.initialSettings, {"uincomingOrder": this.pushInitSettings(config.document_type_settings.incomingOrder)})
            component_x.incomingOrder = config.document_type_settings.incomingOrder
          } 
          if (config.document_type_settings.outgoingOrder != undefined){
            // this.initialSettings.push( {"uoutgoingOrder": this.pushInitSettings(config.document_type_settings.outgoingOrder)} )
            this.initialSettings = Object.assign(this.initialSettings, {"uoutgoingOrder": this.pushInitSettings(config.document_type_settings.outgoingOrder)})
            component_x.outgoingOrder = config.document_type_settings.outgoingOrder
          } 
          if (config.document_type_settings.receivingDocument != undefined){
            // this.initialSettings.push( {"ureceivingDocument": this.pushInitSettings(config.document_type_settings.receivingDocument)} )
            this.initialSettings = Object.assign(this.initialSettings, {"ureceivingDocument": this.pushInitSettings(config.document_type_settings.receivingDocument)})
            component_x.receivingDocument = config.document_type_settings.receivingDocument
          }
          if (config.document_type_settings.receivingDocumentWithOrder != undefined){
            // this.initialSettings.push( {"ureceivingDocumentWithOrder": this.pushInitSettings(config.document_type_settings.receivingDocumentWithOrder)} )
            this.initialSettings = Object.assign(this.initialSettings, {"ureceivingDocumentWithOrder": this.pushInitSettings(config.document_type_settings.receivingDocumentWithOrder)})
            component_x.receivingDocumentWithOrder = config.document_type_settings.receivingDocumentWithOrder
          } 
          if (config.document_type_settings.releasingDocument != undefined){
            // this.initialSettings.push( {"ureleasingDocument": this.pushInitSettings(config.document_type_settings.releasingDocument)} )
            this.initialSettings = Object.assign(this.initialSettings, {"ureleasingDocument": this.pushInitSettings(config.document_type_settings.releasingDocument)})
            component_x.releasingDocument = config.document_type_settings.releasingDocument
          } 
          if (config.document_type_settings.releasingDocumentWithOrder != undefined){
            // this.initialSettings.push( {"ureleasingDocumentWithOrder": this.pushInitSettings(config.document_type_settings.releasingDocumentWithOrder)} )
            this.initialSettings = Object.assign(this.initialSettings, {"ureleasingDocumentWithOrder": this.pushInitSettings(config.document_type_settings.releasingDocumentWithOrder)})
            component_x.releasingDocumentWithOrder = config.document_type_settings.releasingDocumentWithOrder
          } 
          if (config.document_type_settings.transferDocument != undefined){
            // this.initialSettings.push( {"utransferDocument": this.pushInitSettings(config.document_type_settings.transferDocument)} )
            this.initialSettings = Object.assign(this.initialSettings, {"utransferDocument": this.pushInitSettings(config.document_type_settings.transferDocument)})
            component_x.transferDocument = config.document_type_settings.transferDocument
          } 
          if (config.document_type_settings.orderSource != undefined){
            // this.initialSettings.push( {"uorderSource": this.pushInitSettings(config.document_type_settings.orderSource)} )
            this.initialSettings = Object.assign(this.initialSettings, {"uorderSource": this.pushInitSettings(config.document_type_settings.orderSource)})
            component_x.orderSource = config.document_type_settings.orderSource
          } 
          if (config.document_type_settings.customerReturn != undefined){
            // this.initialSettings.push( {"ucustomerReturn": this.pushInitSettings(config.document_type_settings.customerReturn)} )
            this.initialSettings = Object.assign(this.initialSettings, {"ucustomerReturn": this.pushInitSettings(config.document_type_settings.customerReturn)})
            component_x.customerReturn = config.document_type_settings.customerReturn
          }
        }
        component_x.showIncomingOrder =  (component_x.currentDocumentTypeCode=='ORITRQ' || component_x.currentDocumentTypeCode=='ORICSQ' || component_x.currentDocumentTypeCode=='ORIPOX' || component_x.currentDocumentTypeCode=='RELSLO')
        component_x.showOutgoingOrder = (component_x.currentDocumentTypeCode=='OROTRQ' || component_x.currentDocumentTypeCode=='OROCSQ')
        component_x.showReceivingDocument = (component_x.currentDocumentTypeCode=='RECDEL' || component_x.currentDocumentTypeCode=='RECTRX' || component_x.currentDocumentTypeCode=='RECCSX' || component_x.currentDocumentTypeCode=='RECADJ')
        component_x.showReleasingDocument = (component_x.currentDocumentTypeCode=='RELRSR' || component_x.currentDocumentTypeCode=='RELTRX' || component_x.currentDocumentTypeCode=='RELCSX' || component_x.currentDocumentTypeCode=='RELADJ')
        component_x.showReceivingDocumentWithOrder = (component_x.currentDocumentTypeCode=='RECDEL')
        component_x.showReleasingDocumentWithOrder = (component_x.currentDocumentTypeCode=='RELTRX' || component_x.currentDocumentTypeCode=='RELCSX')
        component_x.showTransferDocument = (component_x.currentDocumentTypeCode=='RELTRX')
        component_x.showOrderSourceMode = (component_x.currentDocumentTypeCode=='ORISOX')
        component_x.showPrintSettings = true
        component_x.showCustomerReturn = (component_x.currentDocumentTypeCode=='RECCSR')

        var user_settings = await HTTPRequest.getRequest(this.endPoint + '/user_settings?user_specific=Y&module_name=ORISOX');
        if (user_settings.data.length > 0){
          var data = user_settings.data
          var index = data.findIndex(p => p.module_name == "ORISOX")
          if (index > -1){
            this.orderSource.enableOrderSourceMode = user_settings.data[index].settings_json.isSourceMode
          }else{
            this.orderSource.enableOrderSourceMode = user_settings.data[0].settings_json.isSourceMode
          }
        }
        if (this.documentCode == 'POX' && this.documenttransCode == 'ORI'){
          const index = component_x.priceCostOptions.indexOf("Retail Price");
          if (index > -1) {
            component_x.priceCostOptions.splice(index, 1);
          }
        }
        if ((this.documentCode == 'POX' && this.documenttransCode == 'ORI') || (this.documentCode == 'DEL' && this.documenttransCode == 'REC') || (this.documentCode == 'PUR' && this.documenttransCode == 'OTH')){
          var get_currency_count = await HTTPRequest.getRequest(this.endPoint + 'currencies/total_currency');
          if (get_currency_count["error"] == undefined){
            if (get_currency_count["total"]>0){
              const index = component_x.priceCostOptions.indexOf("Landed Cost");
              if (index > -1) {
                this.priceCostOptions.splice(index, 1);
                if (component_x.priceOrCost == "Landed Cost"){
                  component_x.priceOrCost = "Ordering Cost"
                }
              }
            }
          }
        }
      //  add wholesale price option
        var removeWholesalePrice = true;
        if ((this.documentCode == 'SIN' && this.documenttransCode == 'OTH') || (this.documentCode == 'SOX' && this.documenttransCode == 'ORI')) {
          removeWholesalePrice = false;
        }
        if (removeWholesalePrice) {
          const index = component_x.priceCostOptions.indexOf("Wholesale Price");
          if (index > -1) {
            this.priceCostOptions.splice(index, 1);
          }
        }
      
    },
    methods: {
       moment,
      async create_action_history(action) {
        var actionHistoryPayload = {
            action: action,
            action_at: moment(new Date()),
            action_by: secureStorage.getItem("userName"),
            document_id: this.currentDocumentTypeId,
            status: "A"
        }
        await HTTPRequest.postRequest(this.endPoint + 'document_configuration_action_histories/', null, actionHistoryPayload)
      },
        
      toggleLineRestrictionCheckbox(e) {
        this.editorBehavior.lineRestrictionCheckboxIsDisabled = !e.target.checked
        this.editorBehavior.lineRestrictionCheckbox = e.target.checked
        if (!e.target.checked) {
          this.editorBehavior.lineRestrictionInput = null;
        }
      },
      changePriceOrCost(selectedItem){
        this.priceOrCost = selectedItem;
      },
      getComparison(from, to) {
      console.log(from)
      var diff = function (obj1, obj2) {

      // Make sure an object to compare is provided
      if (!obj2 || Object.prototype.toString.call(obj2) !== '[object Object]') {
          return obj1;
      }

      // Variables

      var diffs = {};
      var key;

      // Methods

      /**
      * Check if two arrays are equal
      * @param  {Array}   arr1 The first array
      * @param  {Array}   arr2 The second array
      * @return {Boolean}      If true, both arrays are equal
      */
      var arraysMatch = function (arr1, arr2) {

          // Check if the arrays are the same length
          if (arr1.length !== arr2.length) return false;

          // Check if all items exist and are in the same order
          for (var i = 0; i < arr1.length; i++) {
              if (arr1[i] !== arr2[i.substring(1)]) return false;
          }

          // Otherwise, return true
          return true;

      };

      /**
      * Compare two items and push non-matches to object
      * @param  {*}      item1 The first item
      * @param  {*}      item2 The second item
      * @param  {String} key   The key in our object
      */
      var compare = function (item1, item2, key) {

          // Get the object type
          var type1 = Object.prototype.toString.call(item1);
          var type2 = Object.prototype.toString.call(item2);

          // If type2 is undefined it has been removed
          if (type2 === '[object Undefined]') {
              diffs[key] = null;
              return;
          }

          // If items are different types
          if (type1 !== type2) {
              diffs[key] = item2;
              return;
          }

          // If an object, compare recursively
          if (type1 === '[object Object]') {
              var objDiff = diff(item1, item2);
              if (Object.keys(objDiff).length > 0) {
                  diffs[key] = objDiff;
              }
              return;
          }

          // If an array, compare
          if (type1 === '[object Array]') {
              if (!arraysMatch(item1, item2)) {
                  diffs[key] = item2;
              }
              return;
          }

          // Else if it's a function, convert to a string and compare
          // Otherwise, just compare
          if (type1 === '[object Function]') {
              if (item1.toString() !== item2.toString()) {
                  diffs[key] = item2;
              }
          } else {
              if (item1 !== item2 ) {
                  diffs[key] = item2;
              }
          }

      };


      //
      // Compare our objects
      //

      // Loop through the first object
      for (key in obj1) {
          if (obj1.hasOwnProperty(key)) {
              compare(obj1[key], obj2[key.substring(1)], key);
          }
      }

      // Loop through the second object and find missing items
      for (key in obj2) {
          if (obj2.hasOwnProperty(key)) {
              if (!obj1[key] && obj1[key] !== obj2[key.substring(1)] ) {
                  diffs[key] = obj2[key.substring(1)];
              }
          }
      }

      // Return the object of differences
      return diffs;

      };

      return diff(from, to);
      },
      async compareMe() {
        this.logSettings = {
          document_type: {
            name: this.documentName,
            friendly_code: this.documentFriendlyCode
          }
        }
        var priceOrCostPayload = {priceOrCost: this.priceOrCost}
        this.logSettings = Object.assign(this.logSettings, priceOrCostPayload)
        var referencesPayload = {references: this.references}
        this.logSettings = Object.assign(this.logSettings, referencesPayload)
        var editorBehaviorPayload = {editorBehavior: this.editorBehavior}
        this.logSettings = Object.assign(this.logSettings, editorBehaviorPayload)
        var additionalEditorBehaviorCheckboxesPayload = {additionalEditorBehaviorCheckboxes: this.additionalEditorBehaviorCheckboxes}
        this.logSettings = Object.assign(this.logSettings, additionalEditorBehaviorCheckboxesPayload)
        var printSettingsPayload = {printSettings: this.printSettings}
        this.logSettings = Object.assign(this.logSettings, printSettingsPayload)
        var outgoingOrderPayload = {outgoingOrder: this.outgoingOrder}
        this.logSettings = Object.assign(this.logSettings, outgoingOrderPayload)
        var incomingOrderPayload = {incomingOrder: this.incomingOrder}
        this.logSettings = Object.assign(this.logSettings, incomingOrderPayload)
        var receivingDocumentPayload = {receivingDocument: this.receivingDocument}
        var receivingDocumentWithOrderPayload = {receivingDocumentWithOrder: this.receivingDocumentWithOrder}
        this.logSettings = Object.assign(this.logSettings, receivingDocumentPayload)
        this.logSettings = Object.assign(this.logSettings, receivingDocumentWithOrderPayload)
        var releasingDocumentPayload = {releasingDocument: this.releasingDocument}
        this.logSettings = Object.assign(this.logSettings, releasingDocumentPayload)
        var releasingDocumentWithOrderPayload = {releasingDocumentWithOrder: this.releasingDocumentWithOrder}
        var transferDocumentPayload = {transferDocument: this.transferDocument}
        this.logSettings = Object.assign(this.logSettings, releasingDocumentWithOrderPayload)
        this.logSettings = Object.assign(this.logSettings, transferDocumentPayload)
        var orderSourcePayload = {orderSource: this.orderSource}
        this.logSettings = Object.assign(this.logSettings, orderSourcePayload)
        var customerReturnPayload = {customerReturn: this.customerReturn}
        this.logSettings = Object.assign(this.logSettings, customerReturnPayload)
        this.diffSettings = []
        
        for (var key in this.initialSettings) {
            if (this.initialSettings.hasOwnProperty(key)) {

                // Comparison
                if(typeof this.initialSettings[key] === 'object') {
                  var objectDiff = this.getComparison(this.initialSettings[key], this.logSettings[key.substring(1)])
                  if( Object.keys(objectDiff).length > 0){
                    for (var keys in objectDiff) {
                        // this.diffSettings.push({"config": keys.substring(1), "from": this.initialSettings[key][keys], "to": objectDiff[keys]})
                        if (objectDiff.hasOwnProperty(keys)) {
                          var configHistoryPayload = {
                                  config: key.substring(1),
                                  config_type: keys.substring(1),
                                  config_from: this.initialSettings[key][keys],
                                  config_to: objectDiff[keys],
                                  config_at: moment(new Date()),
                                  config_by: secureStorage.getItem("userName"),
                                  config_account: secureStorage.getItem("accountId"),
                                  document_type: this.currentDocumentTypeId
                              }
                          // Save config changes
                          await HTTPRequest.postRequest(this.endPoint + 'document_configuration_histories/', null, configHistoryPayload)
                        }
                    }
                  }
                  
                } else {
                  if( this.initialSettings[key] !== this.logSettings[key.substring(1)]) {
                        //this.diffSettings.push({"config": key.substring(1), "from": this.initialSettings[key], "to": this.logSettings[key.substring(1)]})
                        var configHistoryPayload = {
                                  config: key.substring(1),
                                  config_type: key.substring(1),
                                  config_from: this.initialSettings[key],
                                  config_to: this.logSettings[key.substring(1)],
                                  config_at: moment(new Date()),
                                  config_by: secureStorage.getItem("userName"),
                                  config_account: secureStorage.getItem("accountId"),
                                  document_type: this.currentDocumentTypeId
                              }
                          // Save config changes
                          await HTTPRequest.postRequest(this.endPoint + 'document_configuration_histories/', null, configHistoryPayload)
                  }
                }
            }
        }
      },
      pushInitSettings(objSettings){
        var myStringArray = Object.keys(objSettings);
        var arrayLength = myStringArray.length;
        var keysMap = {}
        for (var i = 0; i < arrayLength; i++) {
            keysMap[myStringArray[i]] = 'u' + myStringArray[i];
        }
        return this.renameKeys(keysMap, objSettings)
      },
      renameKeys(keysMap, obj){
        return Object.keys(obj).reduce((acc, key) => {
          const renamedObject = {
            [keysMap[key] || key]: obj[key]
          };
          return {
            ...acc,
            ...renamedObject
          };
        }, {});
      },
      async save() {
        this.spinning = true
        this.compareMe()
        var documentTypePayload = {
          document_type: {
            name: this.documentName,
            friendly_code: this.documentFriendlyCode,
            priceOrCost: this.priceOrCost,
            references: this.references,
            editorBehavior: this.editorBehavior,
            additionalEditorBehaviorCheckboxes: this.additionalEditorBehaviorCheckboxes,
            printSettings:this.printSettings
          }
        }
        var outgoingOrderPayload = {outgoingOrder: this.outgoingOrder}
        documentTypePayload = Object.assign(documentTypePayload, outgoingOrderPayload)
        var incomingOrderPayload = {incomingOrder: this.incomingOrder}
        documentTypePayload = Object.assign(documentTypePayload, incomingOrderPayload)
        var receivingDocumentPayload = {receivingDocument: this.receivingDocument}
        var receivingDocumentWithOrderPayload = {receivingDocumentWithOrder: this.receivingDocumentWithOrder}
        documentTypePayload = Object.assign(documentTypePayload, receivingDocumentPayload)
        documentTypePayload = Object.assign(documentTypePayload, receivingDocumentWithOrderPayload)
        var releasingDocumentPayload = {releasingDocument: this.releasingDocument}
        documentTypePayload = Object.assign(documentTypePayload, releasingDocumentPayload)
        var releasingDocumentWithOrderPayload = {releasingDocumentWithOrder: this.releasingDocumentWithOrder}
        var transferDocumentPayload = {transferDocument: this.transferDocument}
        documentTypePayload = Object.assign(documentTypePayload, releasingDocumentWithOrderPayload)
        documentTypePayload = Object.assign(documentTypePayload, transferDocumentPayload)
        var orderSourcePayload = {orderSource: this.orderSource}
        documentTypePayload = Object.assign(documentTypePayload, orderSourcePayload)
        var customerReturnPayload = {customerReturn: this.customerReturn}
        documentTypePayload = Object.assign(documentTypePayload, customerReturnPayload)

        var user_setting_payload = {"module_name": "ORISOX", "settings_json" : {"isSourceMode": this.orderSource.enableOrderSourceMode}}
        var post_request = await HTTPRequest.postRequest(this.endPoint + 'user_settings/save_order_source', null, user_setting_payload)
        var put_request = await HTTPRequest.putRequest(this.endPoint + 'document_types/save_document_type_settings?id=' + this.currentDocumentTypeId, null, documentTypePayload)
        this.create_action_history("Update")
        if(put_request == undefined){
            this.$emit('refreshPage', event)
            this.$notification['success'](
                {
                    message: "Action succesful",
                    description: "Please refresh page for changes to take effect."
                }
            );
        } else {
            if(put_request["error"] == undefined){
                this.$emit('refreshPage', event)
                this.$notification['success'](
                  {
                      message: "Action succesful",
                      description: "Please refresh page for changes to take effect."
                  }
                );
            } else {
                //this.errors = put_request["error"].split(",");
            }
        }
        this.spinning = false
      },
      checkAutocreationOfSI(value,action){
        if (action=="create" && value)
          this.additionalEditorBehaviorCheckboxes.autoCreateAndPostSalesInvoiceOnPosting = false;
        else if (action=="create&post" && value)
          this.additionalEditorBehaviorCheckboxes.autoCreateSalesInvoiceOnPosting = false;
      },
      checkAutocreationOfDD(value,action){
        if (action=="DD" && value)
          this.additionalEditorBehaviorCheckboxes.autoCreatePostDDAndSI = false;
        else if (action=="DD&SI" && value)
          this.additionalEditorBehaviorCheckboxes.autoCreatePostDD = false;
      }
    }
  }
</script>

<style>
</style>